import React, { useContext } from "react";
import { Navigate } from "react-router-dom";

import { RoutePaths } from "../Constants/RoutePaths";
import { UserAuthenticationContext } from "../Context/UserAuthenticationContext";

interface ModeratorRouteProps {
    children: JSX.Element;
}

const ModeratorRoute: React.FC<ModeratorRouteProps> = ({ children }) => {
    const { userData, userDataLoading, authInitializing } = useContext(
        UserAuthenticationContext
    );

    if (authInitializing || userDataLoading) {
        return <p className="comment-moderation">Checking moderator access…</p>;
    }
    if (!userData?.id) return <Navigate to={RoutePaths.Login} replace />;
    if ((userData.admin_role_id ?? 0) < 95) {
        return <Navigate to={RoutePaths.Root} replace />;
    }
    return children;
};

export default ModeratorRoute;
